import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      component: require("@/components/layouts/mainLayout").default,
      children: [
        {
          path: "/",
          name: "Index.Home",
          component: require("@/views/index").default,
        }
      ]
    }
  ]
});


export default router;